import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { saveProfile, saveGuestProfile } from "../actions/accountActions";
import SocialAccounts from "../components/SocialAccounts";
import { withTranslation } from 'react-i18next';
import Flag from 'react-country-flags';
import Image from "../components/Image";
import { getTranslations } from "../actions/translationActions";
import _ from 'lodash/core';
import Branding from "./Branding";
import ExtendedLink from "../components/ExtendedLink";

class MyRepresentative extends Component {

    handleLanguageChange = newLocale => {
        const { locale } = this.props;
        //  console.log("selected val is ", newLocale);
        if (locale !== newLocale) {
            // if Language is in session storage then load from storage
            //if (newLocale in sessionStorage) {
            if (sessionStorage.getItem(newLocale) !== null) {
                this.changeLanguageAndSaveProfile(newLocale);
                return;
            }
            // else load locale translation from server
            this.loadTranslation(newLocale, true);
        }
    };

    changeLanguageAndSaveProfile = (newLocale, saveProfile = true) => {
        const { user } = this.props;
        this.props.i18n.changeLanguage(newLocale);

        if(saveProfile === false) return;

        if (user.isAuthenticated === true) {
            return this.props.saveProfile({ ...user, locale: newLocale }).then((response) => {
                console.log(response)
            }, (error) => { console.log(error); });
        } else {
            this.props.saveGuestProfile(newLocale);
        }

    };

    loadTranslation(newLocale, saveProfile) {
        this.props.getTranslations(newLocale).then((transResponse) => {
            if (transResponse && transResponse.value.status === 200 && transResponse.value.data) {
                var translationArr = transResponse.value.data;
                const translationObj = translationArr.reduce((obj, item) => {
                    return { ...obj, [item.ResourceId]: item.Value };
                }, {});
                //  this.setState({ translations: translationObj });
                if (_.isEmpty(translationObj) === false) {
                    //sessionStorage[newLocale] = JSON.stringify(translationObj);
                    sessionStorage.setItem(newLocale, JSON.stringify(translationObj));
                    this.props.i18n.addResourceBundle(newLocale, 'translations', translationObj);
                }
                this.changeLanguageAndSaveProfile(newLocale, saveProfile);
            }
        }, (error) => { console.log(error); });
    }

    // To update the site translations after user has logged in
    componentDidUpdate(prevProps) {
        
        const { locale } = this.props;
        if (locale !== prevProps.locale) {
            if (sessionStorage.getItem(locale) !== null) {
                this.changeLanguageAndSaveProfile(locale, false);
                return;
            }
            this.loadTranslation(locale, false);
        }
    }

    render() {

        const { t, locale, user, settings } = this.props;
        const representative = user && user.representative && user.representative.id && user.representative.id !== 0 ? user.representative : settings.defaultRepresentative
        if (!representative)
            return "";

        const { isOpenpayEnabled, isKlarnaEnabled, showOpenpayBanner, showKlarnaBanner } = this.props.settings;

        const phoneNumber = representative.mobile ? representative.mobile : representative.phone;

        // const image = representative.imageUrl ? <Image src={representative.imageUrl} fallbackSrc="img/no-image.jpg" alt='' /> : <i className="icon-head" />;
        const image = representative.imageUrl ? <div className="epr-card-avatar epr-card-avatar-small rounded-circle" style={{backgroundImage: `url(${representative.imageUrl})`}} title={representative.name} ></div>: <i className="icon-head" />;
        const countryCode = locale ? locale.substr(locale.length - 2, 2).toLowerCase() : "";
        const flag = <Flag country={(countryCode === 'aw' ? 'at' :countryCode)} asSquare={true} />;
        const supportMultiLang = settings && settings.supportedCultures && settings.supportedCultures.length > 1;

        const canViewAnonymous = (settings.allowAnonymouse === false && user.isAuthenticated !== true) === false;

        return (
            <Fragment>
                {isOpenpayEnabled && showOpenpayBanner && <div className='navbar navbar-sticky navbar-short'>
                    <opy-info-belt color="amber"></opy-info-belt> </div>}
                {isKlarnaEnabled && showKlarnaBanner && <div className='navbar navbar-sticky navbar-short klarna d-flex  justify-content-center align-items-center'>
                    <img src="img/Klarna/Klarna-logo.svg" /> {t("available at checkout")}
                </div>}

                <div className="topbar">
                    <div className="topbar-column">
                        <div className="toolbar toolbar-left">
                            <div className="inner">
                                <div className="tools">
                                    {canViewAnonymous ?
                                        <div className="account account-img mr-2">
                                            {image}
                                        </div>
                                     :
                                     <Fragment>
                                     <div className="align-middle d-inline mr-2">
                                         <ExtendedLink className="site-logo d-none d-sm-table-cell" to={`${settings.baseUrl}`}>
                                             <img src={(settings.logoUrl ? settings.logoUrl : "img/logo/logo.png")} alt={t("VIP Shop")} />
                                         </ExtendedLink>
                                     </div>
                                     <div className="align-middle shop-welcome">{t("VIP-Shop ENJO Norway")}</div>
                                     </Fragment>
                                    }
                                    {canViewAnonymous &&
                                    <div className="shop-welcome">
                                        {representative.isWebshopOwner
                                            ? `${t("Welcome to")} ${representative.name}${t("'s shop.")}`
                                            : `${representative.name} ${t("is your representative.")}`}
                                        <div className="contact-account-sm d-none">
                                            {representative.email && <a className="pr-2" href={`mailto:${representative.email}`}>
                                                <i className="icon-mail" />&nbsp; {representative.email}
                                            </a>}
                                            {phoneNumber && <a className="pr-2" href={`tel:${phoneNumber}`}>
                                                <i className="icon-bell" />&nbsp; {phoneNumber}
                                            </a>}
                                            <SocialAccounts shape="none" representative={representative} />
                                        </div>
                                    </div>}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="topbar-column">
                        <div className="contact-account">
                            {representative.email && <a className="hidden-md-down pr-2" href={`mailto:${representative.email}`}>
                                <i className="icon-mail" />&nbsp; {representative.email}
                            </a>}
                            {phoneNumber && <a className="hidden-md-down pr-2" href={`tel:${phoneNumber}`}>
                                <i className="icon-bell" />&nbsp; {phoneNumber}
                            </a>}
                            <SocialAccounts shape="none" representative={representative} />
                        </div>
                        <div className="lang-currency-switcher-wrap">
                            <div className={supportMultiLang ? "lang-currency-switcher dropdown-toggle" : "lang-currency-switcher"}>
                                <span className="currency">{settings.currencySymbol}</span>
                                <span className="language" title={t(locale)}>
                                    {flag}
                                </span>
                            </div>
                            {supportMultiLang && (<div className="dropdown-menu">
                                {settings.supportedCultures.map(c => (<a className="dropdown-item" href={null} onClick={() => this.handleLanguageChange(c.code)} key={c.code} >
                                    <span className="flag">
                                        <Flag country={c.code.substr(c.code.length - 2, 2).toLowerCase()} asSquare={true} />
                                    </span>
                                    {t(c.code)}
                                </a>))}
                            </div>)}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

function mapStateToProps({ locale, user, settings }) {
    return { locale, user, settings };
}

export default withTranslation()(connect(mapStateToProps, { saveProfile, saveGuestProfile, getTranslations })(MyRepresentative));
